import { Switch } from "@headlessui/react";
import { Tooltip } from "components/Tooltip";
import { CrawlerFormData } from "pages/crawler/types";
import { cx } from "utils";

const ToggleSwitch = ({
  name,
  label,
  content = "hello",
  watchedValues,
  setValue,
  className,
}: {
  name: keyof CrawlerFormData;
  label: string;
  content?: string;
  watchedValues: any;
  setValue: any;
  className?: string;
}) => (
  <div className="flex items-center gap-2">
    <Switch
      checked={watchedValues[name] as boolean}
      onChange={(checked) => setValue(name, checked as any)}
      className={cx(
        watchedValues[name] ? "bg-rebrandBlue-600" : "bg-gray-200",
        className,
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-rebrandBlue-500 focus:ring-offset-2 cursor-pointer border-2 border-transparent"
      )}
    >
      <span
        className={cx(
          watchedValues[name] ? "opacity-0" : "opacity-100",
          "absolute right-0.5 top-1/2 -translate-y-1/2 text-base font-bold text-white transition-opacity duration-200 flex items-center justify-center w-4 h-4"
        )}
      >
        ×
      </span>
      <span
        className={cx(
          watchedValues[name] ? "opacity-100" : "opacity-0",
          "absolute left-0.5 top-1/2 -translate-y-1/2 text-sm font-bold text-white transition-opacity duration-200 flex items-center justify-center w-4 h-4"
        )}
      >
        ✓
      </span>
      <span
        className={cx(
          watchedValues[name] ? "translate-x-5" : "translate-x-0",
          "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition duration-200 ease-in-out"
        )}
      />
    </Switch>
    <label className="flex items-center text-gray-700">
      <Tooltip content={content}>{label}</Tooltip>
    </label>
  </div>
);

export default ToggleSwitch;
